import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CustomerMapService,
  PlaceModel,
  LatLonModel,
  TrackingModel,
  VehiclesMapModel
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class CustomerMapApiService {
  constructor(private apiService: CustomerMapService) {}

  public getDistancesBetweenCoordinates(latLonModel: LatLonModel[], vehiclesMap?: boolean, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PlaceModel[]> {
    return this.apiService.customerMapDistanceGet(latLonModel, vehiclesMap, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getPlace(latLonModel: LatLonModel, vehiclesMap?: boolean, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PlaceModel> {
    return this.apiService.customerMapPlaceGet(latLonModel, vehiclesMap, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getTracking(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<TrackingModel> {
    return this.apiService.customerMapTrackingGet(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getVehiclesMap(requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehiclesMapModel[]> {
    return this.apiService.customerMapVehiclesGet(requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
